import React from 'react';
import ImageWithPlaceholder from '../../shared/components/image-with-placeholder';

export default ({desktopImageUrl, mobileImageUrl, desktopWidth, isMobile}) => {
    const style =desktopWidth && !isMobile ? { width: desktopWidth, float: 'left', paddingRight: "10px"} : {}
    return(
        <div className='custom-component image-banner' style={style}>
            <ImageWithPlaceholder className='image-wrapper' src={isMobile ? mobileImageUrl : desktopImageUrl}/>
        </div>
    );
}
